import {
  // Dispatch,
  FC,
  FormEventHandler,
  // SetStateAction,
  useState,
} from "react";
import { FormikProps } from "formik";
import { StyledForm } from "./styles";
import { InputFlex } from "../styled-components/input-flex";
import { InputGroup } from "../input-group";
import { tooltipClasses } from "@mui/material";
import { CountriesDropDown } from "../regions/Countries";
import { Checkbox } from "../checkbox";
import { Link } from "react-router-dom";
import { ThemeButton } from "../button";
import { useQuery } from "../../pages/hooks/use-query";
import { GoBackBtn } from "./../button/GoBackBtn";

interface Props {
  path?: "org" | "user";
  formik: FormikProps<any>;
  loading: boolean;
  // setLoading: Dispatch<SetStateAction<boolean>>;
}

type Error = string | false | undefined;

export const RegisterStepOne: FC<Props> = ({
  path = "org",
  formik,
  loading,
  // setLoading,
}) => {
  // Track if terms was agreed or not
  const [termsAgreed, setTermsAgreed] = useState<boolean>(false);

  const type = useQuery("type");

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <>
      {type === "add" ? (
        <>
          <GoBackBtn className="back-btn" />
          <h1>Add my specialist</h1>
          <p>Fill out the details</p>
        </>
      ) : (
        <>
          <h1>Create your account</h1>
          <p>It's free and easy.</p>
        </>
      )}

      <StyledForm onSubmit={handleSubmit}>
        <InputFlex>
          {path === "org" && (
            <InputGroup
              label="Your organization name"
              placeholder="Enter your organization's name"
              name="orgName"
              value={formik.values.orgName}
              width="48%"
              handleChange={formik.handleChange}
              error={(formik.touched.orgName && formik.errors.orgName) as Error}
            />
          )}

          <InputGroup
            label="First name"
            placeholder="Enter your first name"
            name="firstName"
            value={formik.values.firstName}
            width="48%"
            handleChange={formik.handleChange}
            error={
              (formik.touched.firstName && formik.errors.firstName) as Error
            }
            tooltipText={
              <p className={tooltipClasses.tooltip}>
                First name of Diagnostic Centre’s contact person.
              </p>
            }
            className="input"
          />

          <InputGroup
            label="Last name"
            placeholder="Enter your last name"
            name="lastName"
            value={formik.values.lastName}
            width="48%"
            handleChange={formik.handleChange}
            error={(formik.touched.lastName && formik.errors.lastName) as Error}
            tooltipText={
              <p className={tooltipClasses.tooltip}>
                Last name/Surname of Diagnostic Centre’s contact person.
              </p>
            }
            className="input"
          />

          <InputGroup
            label="E-mail"
            placeholder="Type your e-mail"
            name="email"
            value={formik.values.email}
            width="48%"
            handleChange={formik.handleChange}
            error={(formik.touched.email && formik.errors.email) as Error}
          />

          {path === "user" && (
            <InputGroup
              label="Phone number"
              placeholder="Type your phone number"
              type="text"
              name="phoneNumber"
              value={formik.values.phoneNumber}
              width="48%"
              handleChange={formik.handleChange}
              error={
                (formik.touched.phoneNumber &&
                  formik.errors.phoneNumber) as Error
              }
              inputMode={"numeric"}
            />
          )}

          {type !== "add" && (
            <>
              <InputGroup
                label="Password"
                placeholder="Enter your password"
                name="password"
                value={formik.values.password}
                width="48%"
                handleChange={formik.handleChange}
                error={
                  (formik.touched.password && formik.errors.password) as Error
                }
                type="password"
              />

              <InputGroup
                label="Confirm Password"
                placeholder="Confirm your password"
                name="confirmPassword"
                value={formik.values.confirmPassword}
                width="48%"
                handleChange={formik.handleChange}
                error={
                  (formik.touched.confirmPassword &&
                    formik.errors.confirmPassword) as Error
                }
                type="password"
              />
            </>
          )}

          {path === "org" && (
            <>
              <InputGroup
                label="Phone number"
                placeholder="Type your phone number"
                type="text"
                name="phoneNumber"
                value={formik.values.phoneNumber}
                width="48%"
                handleChange={formik.handleChange}
                error={
                  (formik.touched.phoneNumber &&
                    formik.errors.phoneNumber) as Error
                }
                inputMode={"numeric"}
              />

              <InputGroup
                label="LinkedIn URL  (optional)"
                placeholder="Enter your linkedin url"
                name="website"
                value={formik.values.website}
                width="48%"
                handleChange={formik.handleChange}
                error={
                  (formik.touched.website && formik.errors.website) as Error
                }
                type="text"
                tooltipText={
                  <p className={tooltipClasses.tooltip}>
                    Web address your Diagnostic Centre.
                  </p>
                }
                className="input"
              />

              <CountriesDropDown
                className="state"
                countryValue={formik.values.country}
                regionValue={formik.values.state}
                regionLabel="State or Region"
                onChangeCountry={(country: string) => {
                  formik.setFieldValue("country", country);
                }}
                onChangeRegion={(region: string) => {
                  formik.setFieldValue("state", region);
                }}
                width="100%"
                countryError={formik.touched.country && formik.errors.country}
                regionError={formik.touched.state && formik.errors.state}
              />
            </>
          )}
        </InputFlex>

        <Checkbox
          selected={termsAgreed}
          setSelected={setTermsAgreed}
          label={type === "add" ? <>
          By inviting specialist, you agree to the{" "}
          <Link to="/terms">Terms and Conditions</Link>, and our{" "}
          <Link to="/policy">Privacy Policy</Link>
        </> :
            <>
              By creating an account, you agree to the{" "}
              <Link to="/terms">Terms and Conditions</Link>, and our{" "}
              <Link to="/policy">Privacy Policy</Link>
            </>
          }
        />

        <div className="button">
          <ThemeButton type="submit" disabled={loading || !termsAgreed}>
            {loading ? "Setting up ..." :type==="add"? "Verfiy" : "Register"}
          </ThemeButton>
          {type === "add" ? (
            ""
          ) : (
            <small>
              Already have an account? <Link to={"/login"}>Login</Link>
            </small>
          )}
        </div>
      </StyledForm>
    </>
  );
};
